/** PC 管理端菜单权限（与后端 menu: 前缀一致） */

export function isAdminSuper() {
  const v = localStorage.getItem("admin_is_super");
  if (v === null && localStorage.getItem("admin_token")) {
    return true; // 兼容升级前已登录会话
  }
  return v === "1" || v === "true";
}

export function getAdminPermissions() {
  if (isAdminSuper()) return ["*"];
  try {
    const raw = localStorage.getItem("admin_permissions");
    if (!raw) return [];
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function setAdminAuthExtras(user) {
  if (!user) return;
  localStorage.setItem("admin_is_super", user.isSuper ? "1" : "0");
  localStorage.setItem(
    "admin_permissions",
    JSON.stringify(user.permissions || (user.isSuper ? ["*"] : []))
  );
}

export function clearAdminAuthExtras() {
  localStorage.removeItem("admin_is_super");
  localStorage.removeItem("admin_permissions");
}

export function menuRouteVisible(routeKey, perms) {
  if (!perms || perms.includes("*")) return true;
  const menuKey = `menu:${routeKey}`;
  for (const p of perms) {
    if (p === menuKey || p.startsWith(`${menuKey}/`)) return true;
  }
  return false;
}

export function filterMenuItems(items, perms) {
  if (!perms || perms.includes("*")) return items;
  return items
    .map((item) => {
      if (item.superOnly && !isAdminSuper()) return null;
      if (item.children) {
        const children = item.children.filter((c) => menuRouteVisible(c.key, perms));
        if (children.length > 0) return { ...item, children };
        if (menuRouteVisible(item.key, perms)) return { ...item, children: item.children };
        return null;
      }
      return menuRouteVisible(item.key, perms) ? item : null;
    })
    .filter(Boolean);
}

/** 登录后默认跳转：取第一个有权限的叶子菜单 */
export function firstAllowedRoute(perms) {
  const all = [
    "/",
    "/todo/list",
    "/user/list",
    "/house/house",
    "/house/room",
    "/house/bill",
    "/device/electric",
    "/device/water",
    "/device/lock",
    "/order/list",
    "/split/config",
    "/huifu/account",
    "/huifu/bank-card",
    "/system/roles/list",
    "/system/change-password",
    "/system/base",
    "/system/security",
    "/system/columns",
    "/test/wifi-meter",
  ];
  for (const key of all) {
    if (menuRouteVisible(key, perms)) return key;
  }
  return "/test/wifi-meter";
}
